import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["inviteCheckbox", "ownerContainer"]

  connect() {
    // Ensure container is correctly shown or hidden on load.
    this.toggleOwnerFields();
    this.toggleRequiredAttributes();
  }

  toggleOwnerFields() {
    if (this.inviteCheckboxTarget.checked) {
      this.ownerContainerTargets.forEach((element) => {
        element.classList.remove("hidden");
      });
    } else {
      this.ownerContainerTargets.forEach((element) => {
        element.classList.add("hidden");
      });
    }
  }

  toggleRequiredAttributes() {
    // Find all input, select, and textarea elements within the container.
    const inputs = this.ownerContainerTarget.querySelectorAll("input, select, textarea");
    inputs.forEach(input => {
      input.required = this.inviteCheckboxTarget.checked;
    });
  }


  update() {
    this.toggleOwnerFields();
    this.toggleRequiredAttributes();
  }
}
